module.exports = __webpack_public_path__ + "static/media/LazyAz_web6_preview.28ec6775.jpg";